import { AppState } from "../../../../redux-configuration/AppState";
import { BroadcastConversation } from "../../../domain/entities/broadcastConversation";

export const broadcastConversationSelector = (state: AppState): BroadcastConversation => state.messaging.broadcast.broadcastConversation
